var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "align-self-stretch flex-fill d-flex align-items-center justify-content-center",
    },
    [
      _c("div", { staticClass: "text-center" }, [
        _c("h6", [_vm._v("No pending campaigns are found")]),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "btn btn-secondary my-4",
            attrs: { href: _vm.url },
            on: {
              click: function ($event) {
                return _vm.$emit("generate")
              },
            },
          },
          [_c("i", { staticClass: "fas fa-plus" })]
        ),
        _vm._v(" "),
        _c("div", [_vm._v("Press the button to create them")]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }